import { PaymentProfile, PaymentProfileListItem } from './payment-profiles';

export interface PaymentProfilesListResponse {
    content: PaymentProfileListItem[];
    totalElements: number;
}

export type PaymentProfileCreateRequest = Omit<PaymentProfile, 'id' | 'direction' | 'status' | 'createdAt'>;

export type PaymentProfileEditRequest = Omit<PaymentProfile, 'paymentMethodId' | 'direction' | 'status' | 'createdAt'>;
